import React from "react";
import { useNavigate } from "react-router-dom";

const Benifits = () => {
  const navigate = useNavigate();
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="member-benefits customize" id="controlColor">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-benefits mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title" />
            <div className="am-navbar-right">
              <div className="vip-rule">Rules</div>
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="member-benefits-wrapper">
          <div className="member-level-info">
            <div className="level-info">
              <div className="level-img">
                <img src="/assets/images/lv9.be016011.png" alt />
              </div>
              <div className="label-name">VIP0</div>
            </div>
            <div className="level-btn">
              {/* react-text: 1715 */}Upgrade{/* /react-text */}
              <svg className="am-icon am-icon-go-icon_bc3c5dc5 am-icon-md">
                <use xlinkHref="#go-icon_bc3c5dc5" />
              </svg>
            </div>
          </div>
          <div className="rankRewardDetail-wrapper">
            <div className="benefits-title">Salary</div>
            <div className="rankRewardDetail-filter-wrapper">
              {/* react-text: 1721 */}
              {/* /react-text */}
              <div
                className="history-btn"
                style={{ color: "rgb(255, 255, 255)" }}
              >
                <svg className="am-icon am-icon-icon-history_e70a89d5 am-icon-md">
                  <use xlinkHref="#icon-history_e70a89d5" />
                </svg>
                {/* react-text: 1725 */}History{/* /react-text */}
              </div>
            </div>
            <div className="info-wrapper">
              <div className="unlock-time-wrapper">
                <div className="time-info">
                  <div className="unlock-time-title">
                    {/* react-text: 1730 */}Remaining unlock time
                    {/* /react-text */}
                    {/* react-text: 1731 */}:{/* /react-text */}
                  </div>
                  <div className="unlock-time">
                    <div className="wysiwyg" />
                  </div>
                </div>
                {/* react-text: 1735 */}
                {/* /react-text */}
              </div>
            </div>
            <div className="rankRewardDetail-list-wrapper" />
          </div>
          <div className="upConditions-wrapper">
            <div className="benefits-title">Level Up Requirements</div>
            <div className="upConditions-subtitle">
              To level up, all conditions must be fulfilled
            </div>
            <div
              className="swiper-container upConditions-list-wrap swiper-container-initialized swiper-container-horizontal swiper-container-android"
              id="conditions-swiper"
              style={{
                "box-shadow": "rgba(255, 236, 170, 0.3) 0px 0px 0.4rem 0px",
              }}
            >
              <div
                className="swiper-wrapper"
                style={{
                  "-webkit-transition-duration": "0ms",
                  "transition-duration": "0ms",
                  "-webkit-transform": "translate3d(110.333px, 0px, 0px)",
                  "-ms-transform": "translate3d(110.333px, 0px, 0px)",
                  transform: "translate3d(110.333px, 0px, 0px)",
                }}
              >
                <div
                  className="swiper-slide list-item swiper-slide-active"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv9.be016011.png" alt />
                    {/* react-text: 1744 */}VIP0{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div
                        className="item-top"
                        style={{ color: "rgb(166, 163, 157)" }}
                      >
                        0.00
                      </div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div
                        className="item-top"
                        style={{ color: "rgb(166, 163, 157)" }}
                      >
                        0.00
                      </div>
                      <div className="item-mid">/2,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item next swiper-slide-next"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1758 */}VIP1{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" style={{}}>
                        0.00
                      </div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" style={{}}>
                        0.00
                      </div>
                      <div className="item-mid">/20,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1772 */}VIP2{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1786 */}VIP3{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" style={{}}>
                        0.00
                      </div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" style={{}}>
                        0.00
                      </div>
                      <div className="item-mid">/300,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1800 */}VIP4{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/700,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1814 */}VIP5{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/1,200,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1828 */}VIP6{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" style={{}}>
                        0.00
                      </div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" style={{}}>
                        0.00
                      </div>
                      <div className="item-mid">/2,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1842 */}VIP7{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/5,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1856 */}VIP8{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/8,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1870 */}VIP9{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/12,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1884 */}VIP10{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/20,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1898 */}VIP11{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/40,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1912 */}VIP12{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/70,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1926 */}VIP13{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/100,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1940 */}VIP14{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/130,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1954 */}VIP15{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/160,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1968 */}VIP16{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/200,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1982 */}VIP17{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/250,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 1996 */}VIP18{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/300,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2010 */}VIP19{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/340,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2024 */}VIP20{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/380,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2038 */}VIP21{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/420,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2052 */}VIP22{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/480,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2066 */}VIP23{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/540,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2080 */}VIP24{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/620,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2094 */}VIP25{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/700,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2108 */}VIP26{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/800,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2122 */}VIP27{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/900,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2136 */}VIP28{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/1,000,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2150 */}VIP29{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/1,200,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2164 */}VIP30{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/1,500,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2178 */}VIP31{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/2,000,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2192 */}VIP32{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/2,500,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2206 */}VIP33{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/3,000,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide list-item"
                  style={{ width: "110.333px" }}
                >
                  <div className="item-name">
                    <img src="/assets/images/lv18.f4144ae0.png" alt />
                    {/* react-text: 2220 */}VIP34{/* /react-text */}
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top" />
                      <div className="item-mid">-</div>
                      <div className="item-bottom" />
                    </div>
                  </div>
                  <div>
                    <div className="item-info">
                      <div className="item-top">0.00</div>
                      <div className="item-mid">/4,000,000,000.00</div>
                      <div className="item-bottom">0%</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list-item default-title ">
                <div className="item-info">
                  <div className="item-top">Total deposit</div>
                </div>
                <div className="item-info">
                  <div className="item-top">Total bet</div>
                </div>
              </div>
              <div
                className="swiper-pagination swiper-pagination-bullets swiper-pagination-bullets-dynamic"
                style={{ width: "79.1933px" }}
              >
                <span
                  key={0}
                  className="swiper-pagination-bullet swiper-pagination-bullet-active swiper-pagination-bullet-active-main"
                  style={{
                    background: "rgb(166, 163, 157)",
                    left: "31.6773px",
                  }}
                />
                <span
                  key={1}
                  className="swiper-pagination-bullet swiper-pagination-bullet-active-next"
                  style={{ left: "31.6773px", background: "rgb(114, 76, 1)" }}
                />
                <span
                  key={2}
                  className="swiper-pagination-bullet swiper-pagination-bullet-active-next-next"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={3}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px", background: "rgb(114, 76, 1)" }}
                />
                <span
                  key={4}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={5}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={6}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px", background: "rgb(114, 76, 1)" }}
                />
                <span
                  key={7}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={8}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={9}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={10}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={11}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={12}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={13}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={14}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={15}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={16}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={17}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={18}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={19}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={20}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={21}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={22}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={23}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={24}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={25}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={26}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={27}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={28}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={29}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={30}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={31}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={32}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={33}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
                <span
                  key={34}
                  className="swiper-pagination-bullet"
                  style={{ left: "31.6773px" }}
                />
              </div>
              <span
                className="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              />
            </div>
          </div>
          {/* react-empty: 2237 */}
        </div>
      </div>
    </div>
  );
};

export default Benifits;
